module.exports = __webpack_public_path__ + "img/碟片.SLDPRT.20a74061.jpg";